//================================================================
//  Application: Demand Management Portal
//================================================================

//  Product Owner: Laura Bond
//  Created 01/05/24

//================================================================

//Libraries
import React from 'react';
import { Routes, Route } from 'react-router-dom';

//Contexts

//Pages
import NotFound from './Pages/NotFound/NotFound.js';
import Requests from './Pages/Requests/Requests.js'
import MyTasks from './Pages/MyTasks/MyTasks.js';
import Task from './Pages/Task/Task.js';
import GlobalToast from './Components/GlobalToast/GlobalToast.js';

//Components
import Navbar from './Components/Navbar/Navbar';
import Footer from './Components/Footer/Footer.js';

//Styles
import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css';


export default function App() {

  //------------------------------------------------------
  //  Return HTML
  //------------------------------------------------------

  return (  
    <div className='App-Container'>

      {/* Nav */}
      <div className='App-Container-Nav'>
        <Navbar></Navbar>
      </div>

      {/* Body > Contains all pages in the app  */}
      <div className='App-Container-Body'>

        <GlobalToast></GlobalToast>

        <Routes>
          <Route path='/' element={<Requests />} />
          <Route path='/requests' element={<Requests />} />
          <Route path='/requests/:id' element={<Task />} />
          <Route path='/myrequests' element={<MyTasks />} />
          <Route path='/myrequests/:id' element={<Task />} />

          <Route path='*' element={<NotFound />}></Route>
        </Routes>

        <Footer></Footer>

      </div>

    </div>
  )

  //------------------------------------------------------
}